import A from 'const/actionTypes'

export default {
  clearGameInterface: () => {
    return (dispatch, getState) => {
      dispatch({ type: A.CLEAR_GAME_INTERFACE, })
    }
  },
  updateGameInterface: (update) => {
    return (dispatch, getState) => {
      dispatch({
        type: A.UPDATE_GAME_INTERFACE,
        update,
      })
      // const gameInterface = getState().gameInterface
      // Add validations here if needed:
      //
    }
  },
}



// WEBPACK FOOTER //
// ./src/app/actions/gameInterface.js